import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import LightbulbIcon from '@ps-design-system/icons/Lightbulb/Lightbulb20';
import PlusIcon from '@ps-design-system/icons/Plus/Plus20';
import ChevronLeftIcon from '@ps-design-system/icons/ChevronLeft/ChevronLeft20';

import { useUploadModal } from '../../context/UploadModalContext';
import { useUploaderPageData } from '../../context/UploaderPageContext';

const UploaderHeaderWeb = () => {
  const { openMediaModal, openTipsModal } = useUploadModal();
  const { isListing, listingId, router } = useUploaderPageData();

  const handleBackClick = () => {
    router.push(`/mylistings/${listingId}`);
  };

  return (
    <div className="uploader-header">
      {
        isListing && (
          <div className="back-button">
            <Button variant="ghost" prefix={<ChevronLeftIcon />} onClick={handleBackClick} attributes={{ 'data-testing-id': 'upload-page-back' }}>
              <Text typeface="body-2">
                <FormattedMessage id="uploader.page.back" defaultMessage="Back"/>
              </Text>
            </Button>
          </div>
        )
      }
      <div className="title">
        <div className="title-container">
          <div>
            <Text typeface="headline-5-b">
              <FormattedMessage id="uploader.page.header" defaultMessage="Photos and videos"/>
            </Text>
          </div>

          <div>
            <Text typeface="body-2">
              <FormattedMessage id="uploader.drag_and_drop.reorder" defaultMessage="Drag to reorder"/>
            </Text>
          </div>
        </div>

        <div className="buttons">
          <div>
            <Button
              appearance="white"
              variant="outline-1"
              prefix={<LightbulbIcon />}
              onClick={openTipsModal}
            >
              <FormattedMessage id="uploader.tips.header" defaultMessage="Tips"/>
            </Button>
          </div>

          <div className="upload-button">
            <Button appearance="black" prefix={<PlusIcon />} onClick={openMediaModal} attributes={{ 'data-testing-id': 'upload-button-header' }}>
              <FormattedMessage id="uploader.page.upload" defaultMessage="Upload"/>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploaderHeaderWeb;
